import { SupportType } from "@b2bportal/chat-api";
import { SupportChatbot } from "../types";
import { AdaChatConfig } from "../types/ada";

export class AdaSupportChatbot implements SupportChatbot {
  private _isInitialized = false;

  get isInitialized(): boolean {
    return this._isInitialized || Boolean(window.adaEmbed);
  }

  initialize = (config?: AdaChatConfig, onLoad?: () => void): void => {
    if (document.getElementById("__ada") !== null) {
      this._isInitialized = true;
      return;
    }

    window.adaSettings = {
      adaReadyCallback: () => {
        this._isInitialized = true;
        onLoad && onLoad();
      },
      metaFields: { ...(config?.meta || {}) },
    };

    const script = document.createElement("script");
    script.src = "https://static.ada.support/embed2.js";
    script.setAttribute("id", "__ada");
    script.setAttribute("data-handle", import.meta.env.VITE_ADA_DATA_HANDLE);
    script.setAttribute("async", "true");
    window.document.body.appendChild(script);
  };

  toggleSupportChatbot = async (): Promise<void> => {
    await window.adaEmbed?.toggle();
  };

  isChatbotOpen = async (): Promise<boolean> => {
    try {
      const windowInfo = await window.adaEmbed?.getInfo();
      return windowInfo?.isChatOpen || false;
    } catch (error) {
      console.error(`Ada getInfo error: ${error}`);
      return false;
    }
  };

  openSupportChatbot = async (): Promise<void> => {
    const isChatbotOpen = await this.isChatbotOpen();
    if (!isChatbotOpen) {
      await this.toggleSupportChatbot();
    }
  };

  minimizeSupportChatbot = async (): Promise<void> => {
    const isChatbotOpen = await this.isChatbotOpen();
    if (isChatbotOpen) {
      await this.toggleSupportChatbot();
    }
  };

  toggleSupportChatbotButton = (showButton: boolean): void => {
    const chatBtnIFrameEl = document.getElementById("ada-button-frame");
    if (chatBtnIFrameEl) {
      chatBtnIFrameEl.style.display = showButton ? "block" : "none";
    }
  };

  startNewChat = async (supportType?: SupportType): Promise<void> => {
    this.openSupportChatbot();
  };
}
